import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import {
  CheckoutV3GetWebsiteForLoyalties,
  CheckoutV3GetWebsiteForLoyaltiesVariables
} from './__generated__/CheckoutV3GetWebsiteForLoyalties'

export default function useWebsiteForLoyalties() {
  const websiteId = useWebsiteId()
  const {data} = useQuery<
    CheckoutV3GetWebsiteForLoyalties,
    CheckoutV3GetWebsiteForLoyaltiesVariables
  >({
    query: gql`
      query CheckoutV3GetWebsiteForLoyalties($websiteId: ID!) {
        website(websiteId: $websiteId) {
          _id
          loyaltyActive
          loyaltyType
          loyaltyName
          name
          logo {
            _id
            url: resizedURL(height: 200, format: "webp")
          }
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first'
  })

  return data.website
}
